import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.4428 16.946C20.1558 15.708 21.365 13.989 22 12C20.709 7.953 16.7888 5 12.0418 5C10.4048 5 8.86076 5.359 7.48176 5.985L3.49776 2H2V3.375L20.586 22H22V20.586L18.4428 16.946ZM12.0418 7C15.5458 7 18.621 9.026 19.87 12C19.27 13.43 18.2998 14.624 16.9868 15.49L14.7588 13.262C14.9388 12.879 15.0418 12.452 15.0418 12C15.0418 10.343 13.6988 9 12.0418 9C11.5898 9 11.1628 9.103 10.7798 9.283L9.03776 7.54C9.98176 7.203 10.9908 7 12.0418 7Z", clipRule: "evenodd" }), jsx("path", { fill: "currentColor", d: "M12.2454 14.9795L9.06236 11.7965C9.06033 11.824 9.0565 11.8513 9.05266 11.8786C9.04702 11.9186 9.04136 11.9589 9.04136 12.0005C9.04136 13.6575 10.3854 15.0005 12.0414 15.0005C12.083 15.0005 12.1232 14.9948 12.1633 14.9892C12.1906 14.9854 12.2178 14.9815 12.2454 14.9795Z" }), jsx("path", { fill: "currentColor", d: "M4.12976 12C5.37876 14.974 8.53776 17 12.0418 17C12.7218 17 13.3808 16.903 14.0238 16.758L15.6588 18.393C14.5308 18.782 13.3148 19 12.0418 19C7.29476 19 3.29076 16.047 1.99976 12C2.53976 10.308 3.55876 8.811 4.90376 7.637L6.32676 9.061C5.37376 9.862 4.60876 10.859 4.12976 12Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconEyeHidden = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconEyeHidden.displayName = "IconEyeHidden";

export { IconEyeHidden };
